"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const common_utils_1 = require("@zapier/common-utils");
const generateBooleanFieldChoices_1 = __importDefault(require("./generateBooleanFieldChoices"));
const constants_1 = require("../constants");
const injectReplaceChoices = (field, replaceChoices) => {
    if (field.type === 'dict') {
        field.itemFields = [
            {
                type: 'pretty-text',
                replaceChoices,
                isAccordion: true,
            },
        ];
    }
    else if (field.type === 'list' && !field.choices) {
        field.itemFields = [
            {
                type: 'unicode',
                shouldHideLabel: true,
                replaceChoices,
                isAccordion: true,
            },
        ];
    }
    else if (!field.prefill && !field.choices) {
        field.replaceChoices = replaceChoices;
        field.isAccordion = true;
    }
    return field;
};
const groupFields = function (fields) {
    const groupedFields = [];
    const groups = {};
    fields.forEach(function (field) {
        if (field.parent_key) {
            let group = groups[field.parent_key];
            if (!group) {
                group = {
                    type: 'fields',
                    label: common_utils_1.superHumanize(field.parent_key),
                    fields: [],
                    isGroup: true,
                    from_search: field.from_search,
                    from_write: field.from_write,
                    key: '',
                };
                if (field.parent_key) {
                    groups[field.parent_key] = group;
                }
                groupedFields.push(group);
            }
            if (Array.isArray(group.fields)) {
                group.fields.push(field);
            }
        }
        else {
            groupedFields.push(field);
        }
    });
    return groupedFields;
};
function normalizeFieldDefinitions(fields) {
    const formaticFields = _.map(fields, field => {
        field = _.extend({}, field);
        if (field.type === 'boolean') {
            field.type = 'bool';
        }
        if (field.type === 'bool') {
            field.choices = generateBooleanFieldChoices_1.default(field);
        }
        field.zapierType = field.type;
        if (field.type === 'int' ||
            field.type === 'float' ||
            field.type === 'decimal' ||
            field.type === 'datetime' ||
            field.type === 'file') {
            field.isSingleLine = true;
        }
        if (!field.label) {
            field.label = common_utils_1.superHumanize(field.key);
        }
        if (field.prefill && !field.choices) {
            field.choices = {};
        }
        if (field.choices && field.type !== 'bool') {
            field.type = 'pretty-select';
        }
        if (field.type === 'dict' && field.list === true) {
            delete field.list;
        }
        if (field.list === true) {
            field.type = 'list';
        }
        if (field.type === 'list' && field.choices) {
            field.itemFields = [
                {
                    type: 'unicode',
                    shouldHideLabel: true,
                    choices: field.choices,
                },
            ];
        }
        field = injectReplaceChoices(field, constants_1.STATIC_REPLACE_CHOICES);
        return field;
    });
    return groupFields(formaticFields);
}
exports.default = normalizeFieldDefinitions;
